import { create } from 'zustand';
import { UserAction } from '../../../data-access/gql-types/graphql';
import { setCacheData } from '../storage/cache';
import { UserActionsCollectionSegmentPick } from '../types';

type ActionsStore = {
  userActions: UserAction[];
  setActions: (actions: UserActionsCollectionSegmentPick, saveInStorage?: boolean) => void;
  shouldRefetchActions: boolean;
  refetchActions: () => void;
  resetRefetchActions: () => void;
};

export const useActionsStore = create<ActionsStore>()((set) => ({
  userActions: [],
  setActions: (actions: UserActionsCollectionSegmentPick, saveInStorage?: boolean) => {
    const installationId = actions.cacheInfo?.installationId;

    if (installationId && saveInStorage) {
      setCacheData({ kind: 'installation', installationId, perInstallationData: { actions } });
    }

    set(() => ({ userActions: actions.items || [] }));
  },
  shouldRefetchActions: false,
  refetchActions: () => set(() => ({ shouldRefetchActions: true })),
  resetRefetchActions: () => set(() => ({ shouldRefetchActions: false })),
}));
